import { post } from '@/utilities/onwardClient';
import { RETRY_MESSAGES } from '@/constants/apiRoutes';

export const retryMessages = async ({ messages }) => {
    return post(RETRY_MESSAGES, {
        message_ids: messages,
    });
};
